import { memo, useCallback } from 'react';

import { type WorkspaceAgentActionsMenuTask } from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentActionsMenuTasks';
import { preserveWorkspaceAgentComposerFocus } from '~/components/v2/components/workspace/workspace-agent-panel/utils/preserveWorkspaceAgentComposerFocus';

export type WorkspaceAgentActionsMenuTaskRowProps = {
  onSelect: (task: WorkspaceAgentActionsMenuTask) => void;
  task: WorkspaceAgentActionsMenuTask;
};

export const WorkspaceAgentActionsMenuTaskRow = memo(({ onSelect, task }: WorkspaceAgentActionsMenuTaskRowProps) => {
  const handleClick = useCallback(() => {
    onSelect(task);
  }, [onSelect, task]);
  const Icon = task.icon;

  return (
    <button
      className="flex w-full items-center gap-2 rounded-4 px-2 py-2 text-left ads:text-primary text-12 text-gray-12 leading-4 ads:hover:bg-hover-subtle hover:bg-gray-4"
      data-task-id={task.id}
      data-testid="WORKSPACE_AGENT_ACTIONS_MENU_TASK"
      onClick={handleClick}
      onMouseDown={preserveWorkspaceAgentComposerFocus}
      type="button"
    >
      <span aria-hidden className="inline-flex shrink-0 ads:text-icon-default text-gray-10">
        <Icon size="sm" />
      </span>
      <span className="min-w-0 flex-1 truncate">{task.label}</span>
    </button>
  );
});

WorkspaceAgentActionsMenuTaskRow.displayName = 'WorkspaceAgentActionsMenuTaskRow';
